<template>
    <div v-if="page_contents" class="page-content-wrapper">
      <div v-if="showSlider">
        <swiper disabled id="swiper-wrapper" :options="swiperOption" :dir="$vs.rtl ? 'rtl' : 'ltr'" :key="$vs.rtl" >
          <swiper-slide v-for="(content, index) in page_contents"
            :key="index">
            <vx-card class="p-0 overflow-hidden">
              <img class="w-full" :src="content.contentImageUrl" />
            </vx-card>
          </swiper-slide>
        </swiper>
      </div>
    </div>
</template>

<script>
export default {
  name: 'BlogContentPages',
  data () {
    return {
      showSlider: false,
      swiperOption: {
        slidesPerView: 1,
        spaceBetween: (this.isMobile) ? 0 : 15,
        slidesPerGroup: 1,
        loop: this.isMobile,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        },
        loopFillGroupWithBlank: false,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    }
  },
  mounted () {
    if (this.page_contents.length === 0) {
      this.getContentList()
    }
  },
  computed: {
    page_contents () {
      return this.$store.state.api.page_contents
    },
    isMobile () {
      return this.$store.state.api.isMobile
    }
  },
  methods: {
    contentClicked (id) {
      this.$router.push({name: 'promotion', params: {content_id: id }}).catch(() => {})
    },
    getContentList () {

      this.$vs.loading()

      const payload = {
        contentType: 'page',
        isHome: 1,
        page: '1',
        limit: '20'
      }

      this.$store.dispatch('api/contentList', payload)
        .then(() => {
          this.$vs.loading.close()
          if (!this.isMobile) {
            this.swiperOption.slidesPerView = 3
          }
          this.showSlider = true
        })
        .catch(error => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Error',
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })

    }
  }
}
</script>

<style lang="scss">
.page-content-image {
  height: 250px;
  width: 100%;
  border-radius: 10px;


  .vx-card__body {
    padding: 0 !important;
  }
}

.page-image-wrapper {
  width: 100%;
  height: 222px;
  background-size:cover;
  background-position: center;

}

@media (min-width: 860px) {

  .page-image-wrapper {
    height: 222px;
  }
}
</style>
